<template>
  <b-row v-if="session && session.can_undo" class="justify-content-md-center boxes step-back-button">
    <b-col :md="singleColumnButtons && session.is_legacy ? 8 : 9" :lg="singleColumnButtons && session.is_legacy ? 6 : 7" :xl="singleColumnButtons && session.is_legacy ? 6 : 7">
      <b-row class="choice-fields-btns">
        <b-col :md="singleColumnButtons ? 12 : 6">
          <button @click="goBack()" type="button" class="btn-base input-choice-btn input-btn new-btn-outline-success stroke-2x">
            Back
          </button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'StepBackButton',
  props: {
    session: Object,
    singleColumnButtons: Boolean
  },
  methods: {
    goBack: function() {
      this.$emit('back') // go back to the previous step (ignore changes to item selection)
    }
  }
}
</script>

<style scoped>
  .step-back-button  {
    margin-top: 16px !important;
  }

  .step-back-button .new-btn-back {
    min-height: 72px;
    padding: 16px 10px;
  }
</style>
